import React from "react";
import TextFieldComponentLarge from "../TextFieldComponentLarge";

function AdmissionLegal({ legalProblems, handleLegalProblemsChange }) {
  return (
    <div className="container-main-plan margin-bottom-2">
      <div className="tab-container-title-2B">Legal</div>

      <div className="tab-form-container-bis">
        <TextFieldComponentLarge
          title="Legal Problems (past or current)"
          value={legalProblems}
          onChange={handleLegalProblemsChange}
          showValidation={true}
        />
      </div>
    </div>
  );
}

export default AdmissionLegal;

